import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import type { GenericList } from './models/JobSharedInterfaces';
import { GetQuery, PostQuery } from './Shared';

interface TruckToolCheck {
    id: number;
    drillKit: number;
    drillKitNote: string;
    drillBit: number;
    drillBitNote: string;
    truckTools: number;
    truckToolsNote: string;
    staticTruckItems: number;
    staticTruckItemsNote: string;
    notes: string;
    checkCompletedById: number;
}

const TruckToolChecklistData = () => {
    const { truckId, timeOfDay } = useParams();
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [vehicles, setVehicles] = useState<GenericList[]>([]);
    const [currentTruckId, setCurrentTruckId] = useState(-1);
    const [truckName, setTruckName] = useState("");
    const [team, setTeam] = useState<GenericList[]>([]);
    const [toolCheckOptions, setToolCheckOptions] = useState<GenericList[]>([]);
    const initTruckToolCheck: TruckToolCheck = {
        id: 0,
        drillKit: -1,
        drillKitNote: "",
        drillBit: -1,
        drillBitNote: "",
        truckTools: -1,
        truckToolsNote: "",
        staticTruckItems: -1,
        staticTruckItemsNote: "",
        notes: "",
        checkCompletedById: -1
    };
    const [truckToolCheck, setTruckToolCheck] = useState<TruckToolCheck>(initTruckToolCheck);
  
    useEffect(() => {
        window.scrollTo(0, 0);
        setCurrentTruckId(Number(truckId));
        //getData();
    }, []);

    //get data when truck changes
    useEffect(() => {
        window.scrollTo(0, 0);
        if (currentTruckId > 0) {
            getData();
        }
    }, [currentTruckId]);


    const getData = async () => {
        //var toolTruckId = currentTruckId <= 0 ? truckId : currentTruckId;   //cater for current truck not being set yet
        const apiUrl = "GetTruckToolCheckGroupedData?TruckId=" + currentTruckId + '&TimeOfDay=' + timeOfDay;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setToolCheckOptions(result.data.toolCheckOptions);
            setTruckToolCheck(result.data.truckToolCheck);
            setVehicles(result.data.vehicles);
            setTeam(result.data.team);
            //setCurrentTruckId(result.data.truckId);
            setTruckName(result.data.truckName);
            setLoading(false);
        };
    }

    const back = (e: any) => {
        e.preventDefault();
        navigate("/driverjobs");
    }

    const handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errorList = errors;
        if (e.target.value) {
            delete errorList[e.target.name]; 
            setErrors(errorList);
        }

        setTruckToolCheck(prevState => ({ ...prevState, [e.target.name]: e.target.value * 1 }));

        if (e.target.value * 1 === 1) {
            //clear the notes
            setTruckToolCheck(prevState => ({ ...prevState, [e.target.name + "Note"]: "" }));
        }
    }

    const handleChangeText = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errorList = errors;
        if (e.target.value) {
            delete errorList[e.target.name];
            setErrors(errorList);
        }

        setTruckToolCheck(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    }

    const handleTruckChange = (e: any) => {
        //get check list for new truck
        setCurrentTruckId(e.target.value * 1);
    }

    const validate = () => {
        let fields = truckToolCheck;
        let errorList: any = {};
        let formIsValid = true;

        if (!fields.checkCompletedById || fields.checkCompletedById <= 0) {
            formIsValid = false;
            errorList["checkCompletedById"] = "Person Completing Check is required";
        }

        if (!fields.drillKit || fields.drillKit <= 0) {
            formIsValid = false;
            errorList["drillKit"] = "Drill Kit is required";
        }

        if (!fields.drillBit || fields.drillBit <= 0) {
            formIsValid = false;
            errorList["drillBit"] = "Drill Bits are required";
        }

        if (!fields.truckTools || fields.truckTools <= 0) {
            formIsValid = false;
            errorList["truckTools"] = "Truck Tools are required";
        }

        if (!fields.staticTruckItems || fields.staticTruckItems <= 0) {
            formIsValid = false;
            errorList["staticTruckItems"] = "Static Truck Items are required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            saveTruckToolCheck();
        }
    }

    const saveTruckToolCheck = async () => {
        var saveTruck = {
            truckId: currentTruckId,
            truckName: truckName,
            timeOfDay: timeOfDay,
            truckToolCheck: truckToolCheck
        };

        var jsonItem = JSON.stringify(saveTruck);

        const apiUrl = "SaveTruckToolCheckGrouped";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Truck Tool Checklist has been saved");
                navigate("/driverjobs");
            }
        };
    }

    var truckCount = vehicles.length;
    const renderDetails = (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <div className="makeitflexspacebetween marginBottom10">
                    <h2 className="mobile-margin">Truck Tool Check</h2>
                    <a className="mobile-icon-grey" href="#" onClick={(e) => back(e)}>
                        <span className="fas fa-arrow-alt-circle-left mobileMenuSize alignIconCenter"></span>
                    </a>
                </div>

                <span className="hidden">Truck Id: {truckToolCheck.id}</span>
                <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="truckFilterId">
                    <span className="label-mobile--inline-md margin5">Truck</span>
                    <select className="select margin5" id="truckId" name="truckId" value={currentTruckId} onChange={(e) => handleTruckChange(e)} disabled={truckCount <= 1}>
                        <option hidden defaultValue="-1"></option>
                        {vehicles.map(truck =>
                            <option key={truck.id} value={truck.id}>{truck.name}</option>
                        )};
                    </select>
                </label>

                <div className={currentTruckId <= 0 && vehicles.length === 0 ? "" : "hidden"}>
                    <span className="makeitred">There are no jobs allocated to you for today!</span>
                </div>
                <div className={currentTruckId <= 0 ? "hidden" : ""}>
                    <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="checkCompletedById">
                        <span className="label-mobile--inline-md margin5">Person Completing Checks</span>
                        <div className="marginRight10">
                            {team.map(item =>
                                <div className="input-group alignitemscentre" key={item.id}>
                                    <input type="radio" className="marginRight10" id={item.name} name="checkCompletedById" value={item.id} checked={truckToolCheck.checkCompletedById === item.id} onChange={(e) => handleChange(e)}></input>
                                    <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                </div>)
                            }
                        </div>
                    </label>
                    <span className={errors["checkCompletedById"] ? "label errors" : "hidden"}>{errors["checkCompletedById"]}</span>
                    <hr></hr>

                    <h4>Drill Kit</h4>
                    <div className="driverjobs-tools-border marginBottom10">
                        <div className="makeitflex marginLeft5">
                            <div className="driverjobs-tools-itemwidth">
                                <div>2 x Impact Drivers</div>
                                <div>1 x Impact Wrench</div>
                                <div>1 x Cordless Drill</div>
                                <div>4 x Batteries</div>
                                <div>1 x Charger</div>
                                <div>1 x 125mm Hole Saw & Arbour</div>
                                <div>1 x 13mm Drill Bit</div>
                            </div>
                            <div className="driverjobs-tools-locwidth">
                                {toolCheckOptions.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="drillKit" value={item.id} checked={truckToolCheck.drillKit === item.id} onChange={(e) => handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={truckToolCheck.drillKit === 2 || truckToolCheck.drillKit === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                            <hr></hr>
                            <label className="input-group" htmlFor="drillKitNote">
                                <span className="label-mobile--inline-md makeitbold">Drill Kit Notes</span>
                                <input className="input--mobile margin5" maxLength={200} type="text" id="drillKitNote" name="drillKitNote" value={truckToolCheck.drillKitNote} onChange={(e) => handleChangeText(e)}></input>
                            </label>
                        </div>
                    </div>
                    <span className={errors["drillKit"] ? "label errors" : "hidden"}>{errors["drillKit"]}</span>

                    <h4>Drill Bits</h4>
                    <div className="driverjobs-tools-border marginBottom10">
                        <div className="makeitflex marginLeft5">
                            <div className="driverjobs-tools-itemwidth">
                                <div>3 x Rail Bits (18mm Cut Socket)</div>
                                <div>3 x 1/2* Rail Bit Adapters (min)</div>
                                <div>2 x 5/16 Tek Bit (Short)</div>
                                <div>1 x 5/16 Tek Bit (Long)</div>
                                <div>2 x Bugle Bit</div>
                                <div>1 x Phillips Head Screw Driver Bit</div>
                            </div>
                            <div className="driverjobs-tools-locwidth">
                                {toolCheckOptions.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="drillBit" value={item.id} checked={truckToolCheck.drillBit === item.id} onChange={(e) => handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={truckToolCheck.drillBit === 2 || truckToolCheck.drillBit === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                            <hr></hr>
                            <label className="input-group" htmlFor="drillBitNote">
                                <span className="label-mobile--inline-md makeitbold">Drill Bits Notes</span>
                                <input className="input--mobile margin5" maxLength={200} type="text" id="drillBitNote" name="drillBitNote" value={truckToolCheck.drillBitNote} onChange={(e) => handleChangeText(e)}></input>
                            </label>
                        </div>
                    </div>
                    <span className={errors["drillBit"] ? "label errors" : "hidden"}>{errors["drillBit"]}</span>
                        
                    <h4>Truck Tools</h4>
                    <div className="driverjobs-tools-border marginBottom10">
                        <div className="makeitflex marginLeft5">
                            <div className="driverjobs-tools-itemwidth">
                                <div>1 x Hammer</div>
                                <div>1 x Shifter</div>
                                <div>1 x Tape Measure</div>
                                <div>1 x Hand Saw</div>
                                <div>1 x Stanley Knife</div>
                                <div>1 x Tie Wire</div>
                                <div>1 x Carry Tottie</div>
                                <div>1 x Strap Tensioner</div>
                                <div>1 x Strap Crimper</div>
                                <div>1 x Tin Snip</div>
                                <div>1 x Pinch Bar / Crowbar</div>
                                <div>1 x Tool Belt for Screws</div>
                            </div>
                            <div className="driverjobs-tools-locwidth">
                                {toolCheckOptions.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="truckTools" value={item.id} checked={truckToolCheck.truckTools === item.id} onChange={(e) => handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={truckToolCheck.truckTools === 2 || truckToolCheck.truckTools === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                            <hr></hr>
                            <label className="input-group" htmlFor="truckToolsNote">
                                <span className="label-mobile--inline-md makeitbold">Truck Tools Notes</span>
                                <input className="input--mobile margin5" maxLength={200} type="text" id="truckToolsNote" name="truckToolsNote" value={truckToolCheck.truckToolsNote} onChange={(e) => handleChangeText(e)}></input>
                            </label>
                        </div>
                    </div>
                    <span className={errors["truckTools"] ? "label errors" : "hidden"}>{errors["truckTools"]}</span>

                    <h4>Static Truck Items</h4>
                    <div className="driverjobs-tools-border marginBottom10">
                        <div className="makeitflex marginLeft5">
                            <div className="driverjobs-tools-itemwidth">
                                <div>2 x Harnesses</div>
                                <div>1 x Harness M/R Bracket</div>
                                <div>1 x Extension Ladder</div>
                                <div>1 x Step Ladder</div>
                                <div>8 x Truck Binders</div>
                                <div>2 x Hand Binders</div>
                                <div>4 x Traffic Cones</div>
                                <div>1 x First Aid Kit</div>
                            </div>
                            <div className="driverjobs-tools-locwidth">
                                {toolCheckOptions.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="staticTruckItems" value={item.id} checked={truckToolCheck.staticTruckItems === item.id} onChange={(e) => handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={truckToolCheck.staticTruckItems === 2 || truckToolCheck.staticTruckItems === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                            <hr></hr>
                            <label className="input-group" htmlFor="staticTruckItemsNote">
                                <span className="label-mobile--inline-md makeitbold">Static Truck Item Notes</span>
                                <input className="input--mobile margin5" maxLength={200} type="text" id="staticTruckItemsNote" name="staticTruckItemsNote" value={truckToolCheck.staticTruckItemsNote} onChange={(e) => handleChangeText(e)}></input>
                            </label>
                        </div>
                    </div>
                    <span className={errors["staticTruckItems"] ? "label errors" : "hidden"}>{errors["staticTruckItems"]}</span>

                    <label className="input-group" htmlFor="notes">
                        <span className="label-mobile makeitbold">Additional Notes</span>
                        <p>Add any additional notes that may be required based on the choices you have made.</p>
                        <textarea className="input marginLeft0 job__noteSize label-mobile" id="notes" name="notes" value={truckToolCheck.notes} onChange={(e) => handleChangeText(e)}></textarea>
                    </label>

                    <div className="defaultbutton__container--right marginTop10">
                        <a className="mobile-icon-green" href="#" onClick={(e) => save(e)}>
                            <span className="fas fa-circle-check mobileMenuSize alignIconCenter"></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return <div>
        {contents}
    </div>;
}

export default TruckToolChecklistData;